
import React from 'react';
import { HttpsRequest, GetAuth, Session } from '../component/Utils';
import { Loading } from '../component/BaseComponent';
import { APPRoute } from '../component/texts';


 

type LogoutState = {
    isbusy: boolean;
}

class LogoutComp extends React.Component<IProps, LogoutState> {

    constructor(props: IProps) {

        super(props);
        this.state = {
            isbusy: true
        }
    }
    render(): React.ReactNode {

        return (
            <>
                {
                    this.state.isbusy && <Loading />
                }
            </>
        )

    }

    logout = (resp: RespArgs) => {
        Session.clear();
        this.props.navigate(APPRoute.login);
        
        if (resp.status === 0)
            this.setState({ isbusy: false })
        
    }

    componentDidMount() {
         
        HttpsRequest.get(
            "/logout", this.logout, GetAuth(),
            {}, this.logout
        )
    }

}




export default LogoutComp  